var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.111,
    height: 38.896,
    viewBox: "0 0 28.111 38.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "NO_NAME",
    "data-name": "NO NAME",
    transform: "translate(-202.483 -1172.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2050",
    "data-name": "Path 2050",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M221.374,1172.221H202.483v38.9h28.111V1181.3Z",
    fill: "#5d5d5d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_2051",
    "data-name": "Path 2051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M221.374,1172.221l9.22,9.087h-9.22Z",
    fill: "#5d5d5d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_2052",
    "data-name": "Path 2052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M216.552,1203.517a1.618,1.618,0,0,1-.017-3.235h.017a1.617,1.617,0,0,1,0,3.235Zm-.146-6.467a1.618,1.618,0,0,1-.512-3.152c.969-.328,3.745-1.645,3.745-3.317a3.236,3.236,0,0,0-6.288-1.08,1.617,1.617,0,0,1-3.052-1.072,6.472,6.472,0,0,1,12.575,2.152c0,4.277-5.347,6.182-5.957,6.386A1.634,1.634,0,0,1,216.406,1197.05Z",
    fill: "#ef5c41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoName);
export default __webpack_public_path__ + "static/media/no-Name.11df3d78a9cb05e7de37ebd5a9e8e96a.svg";
export { ForwardRef as ReactComponent };